import { render, staticRenderFns } from "./DialogWallet.vue?vue&type=template&id=64813f76&scoped=true"
import script from "./DialogWallet.vue?vue&type=script&lang=js"
export * from "./DialogWallet.vue?vue&type=script&lang=js"
import style0 from "./DialogWallet.vue?vue&type=style&index=0&id=64813f76&prod&lang=scss"
import style1 from "./DialogWallet.vue?vue&type=style&index=1&id=64813f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64813f76",
  null
  
)

export default component.exports